import { ca } from '@cian/analytics';

import { OFFERS_ON_PAGE } from '../constants/listing';
import { trackingReasonToListingType } from '../constants/tracking';
import { ITrackOfferActionsProps } from '../types/tracking';

export function trackHideOffer({
  offerPosition,
  offerId,
  offersLength,
  pageNumber,
  gaLabel,
  reason,
  jsonQuery,
  queryString,
  isCianPartner,
  partnerUrl,
}: ITrackOfferActionsProps) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'HideObject',
    action: 'Click_icon',
    label: gaLabel,
    page: {
      pageType: 'ListingHybrid',
      listingType: trackingReasonToListingType[reason],
      offersQty: offersLength < OFFERS_ON_PAGE ? offersLength : OFFERS_ON_PAGE,
      pageNumber,
      extra: {
        reason,
        mobileWebsiteType: 'new',
      },
      // Когда мкс отображается на ЧПУ ссылке queryString можно получить только из стейта
      queryString: window.location.search || queryString,
    },
    products: [
      {
        id: offerId,
        position: offerPosition,
        offerType: 'offer',
        extra: { isPartner: isCianPartner, partner_url: partnerUrl },
      },
    ],
    sc: jsonQuery,
  });
}
